/**  @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ApiVariableInsurancesRankResponse,
  ApiVariableInsurancesRankResponseInsurancesInner,
} from "../../../../openApi/api";
import { ContentsColumnVariable } from "./ContentsColumnVariable";
import { HeadColumnCommonSub } from "./HeadColumnCommon";
import { HeadColumnVariable } from "./HeadColumnVariable";

interface Props {
  typeOfInsurance: number;
  response: ApiVariableInsurancesRankResponse | undefined;
  age: number;
  sex: number;
  setIsPopupOpen: (isPopupOpen: boolean) => void;
  setFocusedIndex: (focusedIndex: number) => void;
  insuranceListInCart: ApiVariableInsurancesRankResponseInsurancesInner[];
  setInsuranceListInCart: (
    prevCart: ApiVariableInsurancesRankResponseInsurancesInner[]
  ) => void;
  insuranceIdListInCart: string[];
  setInsuranceIdListInCart: (insuranceIdListInCart: string[]) => void;
  // 収入補償保険特有のprops
  triggerVariableInsuranceRankAPI: boolean;
  setTriggerVariableInsuranceRankAPI: (_: boolean) => void;
  
  checkedRankList: string[];
  setCheckedRankList: (checkedRankList: string[]) => void;
  
  isContentsColumnRendered: boolean;
  setIsContentsColumnRendered: (isContentsColumnRendered: boolean) => void;
}

export const TableVariable = ({
  typeOfInsurance,
  response,
  age,
  sex,
  setIsPopupOpen,
  setFocusedIndex,
  insuranceListInCart,
  setInsuranceListInCart,
  insuranceIdListInCart,
  setInsuranceIdListInCart,
  triggerVariableInsuranceRankAPI,
  setTriggerVariableInsuranceRankAPI,
  
  checkedRankList,
  setCheckedRankList,
  
  isContentsColumnRendered,
  setIsContentsColumnRendered,
}: Props) => {
  
  const [isDisplayOnlyChecked, setIsDisplayOnlyChecked] = useState<boolean>(false);

  useEffect(() => {
    setIsContentsColumnRendered(true);
  }, [
    isDisplayOnlyChecked,
    setIsDisplayOnlyChecked,
    setIsContentsColumnRendered
  ]);
  
  return (
    <section className="comparisonTableSection">
      <Container>
        <Row>
          <Col className="speechBoxContainer" md={1}>
            <div className="speechBox">
              保障内容でも
              <br />
              絞り込み可能
            </div>
          </Col>
          <Col md={1} className="insuranceTableTitle">
            {response?.table_header_text}
          </Col>
        </Row>
      </Container>
      <div className="insuranceTable">
        <div className="headRow">
          <HeadColumnCommonSub
            isDisplayOnlyChecked={isDisplayOnlyChecked}
            setIsDisplayOnlyChecked={setIsDisplayOnlyChecked}
            isContentsColumnRendered={isContentsColumnRendered}
            setIsContentsColumnRendered={setIsContentsColumnRendered}
          />
          <div className="headRowSpecific">
            <HeadColumnVariable
              triggerVariableInsuranceRankAPI={
                triggerVariableInsuranceRankAPI
              }
              setTriggerVariableInsuranceRankAPI={
                setTriggerVariableInsuranceRankAPI
              }
              isContentsColumnRendered={isContentsColumnRendered}
              setIsContentsColumnRendered={setIsContentsColumnRendered}
            />
          </div>
        </div>
        <div className="contentRow">
          {response?.insurances &&
            response?.insurances.map(
              (
                insurance: ApiVariableInsurancesRankResponseInsurancesInner,
                index: number
              ) =>
                !isDisplayOnlyChecked ||
                (isDisplayOnlyChecked &&
                  checkedRankList.includes(insurance.insurance_id ?? '')) ? (
                  <ContentsColumnVariable
                    key={`${typeOfInsurance}_${index + 1}`}
                    typeOfInsurance={typeOfInsurance}
                    insurance={insurance}
                    age={age}
                    sex={sex}
                    lowPriceRank={index + 1}
                    setIsPopupOpen={setIsPopupOpen}
                    setFocusedIndex={setFocusedIndex}
                    insuranceListInCart={insuranceListInCart}
                    setInsuranceListInCart={setInsuranceListInCart}
                    insuranceIdListInCart={insuranceIdListInCart}
                    setInsuranceIdListInCart={setInsuranceIdListInCart}
                    checkedRankList={checkedRankList}
                    setCheckedRankList={setCheckedRankList}
                    setIsContentsColumnRendered={setIsContentsColumnRendered}
                    numberOfInsurances={response?.insurances?.length}
                  />
                ) : (
                  <div key={index + 1}></div>
                )
            )}
        </div>
      </div>
    </section>
  );
};
